<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    fixed
    temporary
    overlay-color="#000"
    overlay-opacity="0.7"
    disable-resize-watcher
  >
    <v-list nav dense>
      <v-list-item-group>
        <template v-if="!isAuthenticated">
          <v-list-item class="drawer-login-btn m-4" @click="openLoginModal">
            <span>
              {{ $t("header.login") }} / {{ $t("header.signUpForFree") }}
            </span>
          </v-list-item>
          <v-divider class="mt-4 mb-2" />
        </template>
        <template v-else>
          <div class="mb-2 p-3 pt-6">
            <v-expansion-panels accordion flat>
              <v-expansion-panel>
                <div>
                  <img
                    v-if="profilePictureUrl"
                    class="rounded-circle mb-3"
                    width="40"
                    height="40"
                    :src="profilePictureUrl"
                    alt="profile"
                  />
                  <v-icon
                    color="white"
                    size="26"
                    class="rounded-circle mb-3 bg-success p-2"
                    v-else
                    >mdi-account</v-icon
                  >
                </div>
                <v-expansion-panel-header class="ml-0">
                  <div class="d-flex flex-column">
                    <p class="user-name">{{ fullName }}</p>
                    <p class="user-email">{{ userEmail }}</p>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-for="menu_list in headerData.header_menu[userType]"
                  :key="menu_list.id"
                >
                  <div class="sm-categories-list">
                    <router-link :to="{ name: menu_list.componentName }">
                      {{ $t("header." + menu_list.name) }}
                    </router-link>
                  </div>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <Logout :isMobile="true" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-divider class="my-2" />
        </template>
        <div class="m-2">
          <div
            v-for="headerList in headerData.headerLinks"
            :key="headerList.id"
          >
            <v-expansion-panels
              v-if="headerList.subMenu && headerList.subMenu.length"
              accordion
              flat
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t("header." + headerList.name) }}
                </v-expansion-panel-header>
                <v-expansion-panel-content
                  v-for="subMenuLink in headerList.subMenu"
                  :key="subMenuLink.id"
                >
                  <div v-if="subMenuLink.hasCategories">
                    <v-expansion-panels accordion flat>
                      <v-expansion-panel>
                        <v-expansion-panel-header>
                          {{ subMenuLink.name }}
                        </v-expansion-panel-header>
                        <v-expansion-panel-content style="padding: 0">
                          <div class="sm-categories-list">
                            <router-link
                              v-for="category in subMenuLink.categories"
                              :key="category.id"
                              :to="{
                                name: category.componentName,
                                params: { id: category.id },
                              }"
                            >
                              {{ category.name }}
                            </router-link>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </div>
                  <router-link v-else :to="{ name: subMenuLink.componentName }">
                    {{ instituteName }}
                  </router-link>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-list-item
              v-else-if="!hideForKuttab(headerList.hideForAlkuttab)"
              class="drawer-list-item"
            >
              <router-link
                v-if="headerList.componentName"
                :to="{ name: headerList.componentName }"
                :class="{ disabled: headerList.isDisabled }"
                exact
              >
                {{ $t("header." + headerList.name) }}
              </router-link>
              <a :href="headerList.link" v-else-if="headerList.link">
                {{ $t("header." + headerList.name) }}
              </a>
            </v-list-item>
          </div>
        </div>
        <v-list-item class="mt-4 p-0 mx-2">
          <SwitchLang :drawer="true" />
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import SwitchLang from "@/components/SwitchLang.vue"
import ProfileMenu from "@/components/global/ProfileMenu.vue"
import Logout from "@/components/Logout.vue"

export default {
  name: "MobileNavigationDrawer",
  components: {
    SwitchLang,
    ProfileMenu,
    Logout,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    headerData: {
      type: Object,
      required: true,
    },
    instituteLogo: {
      type: String,
      required: true,
    },
    instituteName: {
      type: String,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    userType: {
      type: String,
      default: "",
    },
    institute: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fullName() {
      return `${this.$store.getters.StateUser.user.first_name} ${this.$store.getters.StateUser.user.last_name}`
    },
    userEmail() {
      return this.$store.getters.StateUser.user.email
    },
    profilePictureUrl() {
      return this.$store.getters.StateUser.user.profile_picture_url
    },
    drawer: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    openLoginModal() {
      window.dispatchEvent(
        new CustomEvent("loginModalChange", {
          detail: {
            opened: true,
            tab: 0,
          },
        })
      )
    },
    hideForKuttab(isHideForKuttab) {
      if (isHideForKuttab) {
        if (this.institute.id === 1) {
          return false
        }
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-content__wrap {
  border: none;
  padding: 0px;
}

.user-name {
  margin-bottom: 7px;
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
  color: $title;
}

.user-email {
  font-size: 12px;
  margin-bottom: 0;
  color: $description;
}

.drawer-list-item {
  font-weight: 600;
  color: rgb(119, 119, 119);
}

.drawer-list-item > a {
  width: 100%;
  color: rgb(119, 119, 119);
}

.drawer-login-btn {
  font-size: 14px;
  font-weight: 600;
  background: $hover-green;
  span {
    color: $white;
    width: 100%;
    text-align: center;
  }
}

.sm-categories-list {
  display: flex;
  flex-direction: column;
  z-index: 1000;
  min-width: 120px;
  a {
    padding: 5px;
    border-radius: 2px;
    font-weight: 600;
    color: $title;
    width: 100%;
    &:hover {
      color: $hover-green;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}

.v-navigation-drawer {
  padding: 0px;

  .v-list {
    padding: 0;

    .v-expansion-panels {
      padding: 0;

      .v-expansion-panel {
        .v-expansion-panel-header {
          font-size: 16px;
          padding: 0;
          margin: 0px;
          margin-left: 5px;
        }

        &.v-expansion-panel--active {
          .v-expansion-panel-header {
            min-height: auto;
            padding: 16px 0;
            font-size: 16px;
            min-height: auto;
            padding: 8px 0;
            font-weight: 600;
            color: $darker-green;
          }

          button {
            padding: 0;
          }

          .v-expansion-panel-content {
            .v-expansion-panel-content__wrap {
              padding: 0 10px;
            }
          }
        }
      }
    }
  }

  .v-list-item:has(a.active) {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
    margin: 4px 0;
  }

  a {
    text-decoration: none;
    font-family: $font-family;
    line-height: 24px;
    color: $title;
    margin-inline-start: 0;
    font-weight: 500;
    font-size: 14px;
    &.active {
      color: $hover-green;
      font-weight: 600;
    }

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
</style>
